import axios from "axios";

// Use same origin when no explicit backend URL is configured.
// This avoids cross-domain DNS lookups + mobile carrier routing issues
// after binding a custom domain (e.g., güvenkimya.com).
const RAW_BACKEND_URL = (process.env.REACT_APP_BACKEND_URL || "").trim();
const BACKEND_URL = RAW_BACKEND_URL && RAW_BACKEND_URL !== "/" ? RAW_BACKEND_URL : "";
export const API = `${BACKEND_URL}/api`;

// Auth token storage — uses sessionStorage (cleared when tab closes)
// rather than localStorage, so the token doesn't linger between sessions.
const TOKEN_KEY = "gk_token";

export const authStorage = {
  get token() {
    return sessionStorage.getItem(TOKEN_KEY);
  },
  setToken(t) {
    if (t) sessionStorage.setItem(TOKEN_KEY, t);
    else sessionStorage.removeItem(TOKEN_KEY);
  },
  clear() {
    sessionStorage.removeItem(TOKEN_KEY);
  },
};

export function resolveImage(url) {
  if (!url) return "";
  if (url.startsWith("http://") || url.startsWith("https://") || url.startsWith("data:")) return url;
  if (url.startsWith("/")) return `${BACKEND_URL}${url}`;
  return url;
}

const api = axios.create({
  baseURL: API,
  timeout: 30000, // 30s — mobile data may be slow
});

api.interceptors.request.use((config) => {
  const token = authStorage.token;
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401) {
      const path = window.location.pathname;
      if (path.startsWith("/admin") && path !== "/admin/login") {
        authStorage.clear();
        window.location.href = "/admin/login";
      }
    }
    return Promise.reject(err);
  }
);

export default api;

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Bir hata oluştu. Lütfen tekrar deneyin.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
